module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-tabs', {
    staticClass: "tab-nav",
    attrs: {
      "sticky": ""
    },
    on: {
      "click": _vm.onStatusChange
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tab', {
    attrs: {
      "title": "进行中"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "未开始"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "已结束"
    }
  }), _vm._v(" "), _c('van-tab', {
    attrs: {
      "title": "全部"
    }
  }), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('van-cell-group', _vm._l((_vm.list), function(row, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "title": row.title,
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.goDetail(row)
        }
      }
    }, [_c('template', {
      slot: "label"
    }, [_c('span', {
      staticClass: "font-size0 van-color-text-assist"
    }, [_vm._v(_vm._s(row.saiqu_name))])]), _vm._v(" "), [(row.status == 1) ? _c('span', {
      staticStyle: {
        "color": "#1989fa"
      }
    }, [_vm._v("未开始")]) : (row.status == 2) ? _c('span', {
      staticStyle: {
        "color": "#32ae57"
      }
    }, [_vm._v("进行中")]) : (row.status == 3) ? _c('span', {
      staticStyle: {
        "color": "#999"
      }
    }, [_vm._v("已结束")]) : (row.status == 4) ? _c('span', {
      staticStyle: {
        "color": "#999"
      }
    }, [_vm._v("已结束")]) : _vm._e()]], 2)
  }), 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-790164a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/score/StartListOption.vue
// module id = 2505
// module chunks = 0